import BadgesSpotlightBoxContainer from './BadgesSpotlightBox.container';
import BadgesSpotlightBox from './BadgesSpotlightBox';
export default BadgesSpotlightBoxContainer(BadgesSpotlightBox);
